export default __webpack_public_path__ + "static/media/qatar-flag.f3dfaf47.svg";